import styled from 'styled-components';
import { secondary } from '../App/theme';

export const Card = styled.div`
  border: 1px solid ${secondary.main};
  box-sizing: border-box;
  border-radius: 25px;
  width: 60%;
  padding: .5vw;
  padding-bottom: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  margin-top: 6px;
  word-break: break-word;
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const Title = styled.div`
  font-size: 14px;
  line-height: 14px;
  color: ${secondary.main};
`;

export const Description = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.011em;
  color: #333333;
  padding: 10px;
  padding-top: 0;
`;

export const CheckboxContent = styled.div`
  &:hover {
    cursor: pointer;
  }
`;